import { TabContext, TabPanel } from "@mui/lab";
import {
  Box,
  Checkbox,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";
import { observer } from "mobx-react-lite";
import { Fragment, useEffect, useState } from "react";
import { BiSave } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  MCCommandDetailModel,
  RoutingRates,
  WorkOrderRoutings,
  workOrderRates,
} from "services/matchCardCommand_services";
import { User } from "services/user_services";
import * as rootStore from "stores/root_store";
import { formatNumber } from "utils/formatHelper";
import { getUserSession } from "utils/localStorageHelper";

export function createMatchCardCommandDetail() {
  return observer(() => {
    const styles = {
      MuiTableCellRoot: {
        fontSize: "13px",
        fontWeight: 700,
        padding: "5px 10px",
        lineHeight: "20px",
        color: "white",
      },
      borderInherit: {
        borderCollapse: "inherit",
      },
      MuiTableCellRootTd: {
        fontSize: "13px",
        padding: "5px 15px",
        lineHeight: "20px",
        borderBottom: "unset",
      },
      sticky1: {
        position: "sticky",
        left: 0,
        background: "white",
        zIndex: 5,
      },
      sticky2: {
        position: "sticky",
        left: 120,
        background: "white",
        zIndex: 5,
      },
      MuiBoxRoot: {
        width: "100%",
        typography: "body1",
      },
      MuiButtonBaseRoot: {
        fontSize: "13px",
        fontWeight: 500,
      },
    };
    const column = [
      {
        columnName: "Thứ tự công đoạn",
        align: "text-center",
        visible: true,
        sticky: "sticky left-0  z-10",
      },
      {
        columnName: "Mã công đoạn",
        align: "text-center",
        visible: true,
        sticky: "sticky left-[120px] z-10 shadow-3xl",
      },

      {
        columnName: "Tên công đoạn",
        align: "text-center",
        visible: true,
      },

      {
        columnName: "Hướng dẫn sản xuất",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "NVL sử dụng",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Khuôn sử dụng",
        align: "text-center",
        visible: true,
      },

      {
        columnName: "Số SP/ Tờ/ Công đoạn",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Số lượng thực hiện theo từng công đoạn",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "ĐVT công đoạn",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Tổng số sản phẩm",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "% Ước tính hoàn thành",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Thời gian chuẩn bị máy(min)",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Thời gian định mức (min)",
        align: "text-center",
        visible: true,
      },
      { columnName: "Ghép bài", align: "text-center", visible: true },
      {
        columnName: "Tỷ lệ",
        align: "text-center",
        visible: true,
      },
    ];

    // get MCCommand ID
    const { matchCardCommandId = "" } = useParams();
    // =================== STATE =============================
    const [matchCardCommand, setMatchCardCommand] = useState<
      MCCommandDetailModel | undefined
    >({
      matchCardCode: "",
      printItem: "",
      workOrderCodes: "",
      printCompany: "",
      designVote: "",
      printReqDate: "",
      workOrderMCs: [],
      routingRates: [],
    });

    // set initial value cho Tab để hiển thị màn hình vào tab có value tương ứng
    const [value, setValue] = useState("rateMCCommand");

    const [isLoading, setIsLoading] = useState(true);

    //  danh sách worounting
    const [WORouting, setWORouting] = useState<WorkOrderRoutings[]>();
    //  danh sách của routing rates
    const [routingRates, setRoutingRates] = useState<RoutingRates[]>();

    // phân quyền nút lưu
    const [isEdit, setIsEdit] = useState(false);
    // =================== FUNCTION ==========================
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue);
      setWORouting(
        rootStore.mCComandStore.mCCommandDetailResponse.data?.workOrderMCs.find(
          (item) => item.workOrderCode === newValue
        )?.workOrderRoutings
      );
    };

    // thay đổi giá trị của ô input
    const handleChangeValueProductPage = (
      e: React.ChangeEvent<HTMLInputElement>,
      index: number,
      index2: number,
      item2: workOrderRates
    ) => {
      if (routingRates) {
        const temp = [...routingRates];
        temp[index].workOrderRates[index2].productPerPage = Number(
          e.target.value
        );
        const isCheck = temp[index].workOrderRates.filter((i) => i.matchCard);
        // tính tổng rate của những phần tử sau khi lọc
        const currentTemp = isCheck.reduce((a, b) => a + b.productPerPage, 0);

        // cập nhật lại rate của bản thân phần tử
        temp[index].workOrderRates[index2].rated =
          (temp[index].workOrderRates[index2].productPerPage / currentTemp) *
          100;
        // cập nhật lại isEdit của bản thân phần tử
        temp[index].isEdit = true;
        isCheck.forEach(
          (i) => (i.rated = (i.productPerPage / currentTemp) * 100)
        );
        if (!temp[index].workOrderRates[index2].matchCard) {
          temp[index].workOrderRates[index2].rated = 0;
        }
        setRoutingRates(temp);
      }
    };

    // lưu thay đổi của bảng chia tỉ lệ ghép bài
    const handleEditRouting = async () => {
      setIsLoading(true);
      if (routingRates) {
        const data = routingRates
          .filter((i) => i.isEdit)
          .map((item) => {
            const data2 = item.workOrderRates
              .filter((item2) => {
                if (!item2.isDisable) {
                  return item2;
                } else return false;
              })
              .map((item3) => {
                return {
                  workOrderCode: item3.workOrderCode,
                  stepCode: item.stepCode,
                  orderIndex: item.orderIndex,
                  productPerPage: item3.productPerPage,
                  rated: item3.rated,
                  isMatchCard: item3.matchCard,
                };
              });
            return data2;
          });
        // console.log(data.flat(1).map((item) => item.rated));
        await rootStore.mCComandPresenter.updateMCWORouting(
          rootStore.mCComandStore,
          {
            woRoutingUpdates: data.flat(1),
          }
        );
        console.log(data.flat(1));

        await rootStore.mCComandPresenter.getMCCommandDetail(
          rootStore.mCComandStore,
          matchCardCommandId
        );
        setMatchCardCommand(
          rootStore.mCComandStore.mCCommandDetailResponse.data
        );
        setIsLoading(false);
        if (rootStore.mCComandStore.updateMCWORoutingResponse.isSuccess) {
          toast.success(
            rootStore.mCComandStore.updateMCWORoutingResponse.message
          );
          setRoutingRates(
            routingRates.map((item) => {
              return {
                ...item,
                isEdit: false,
              };
            })
          );
        } else {
          toast.error(
            rootStore.mCComandStore.updateMCWORoutingResponse.message
          );
        }
      }
    };

    // tính tỷ lệ rate dựa trên số tờ và element đc checked
    const handleCalcRate = (
      index: number,
      index2: number,
      item2: workOrderRates
    ) => {
      if (routingRates) {
        const temp = [...routingRates];
        // handle Check, thay đổi check và không check
        temp[index].workOrderRates[index2].matchCard = !item2.matchCard;

        //kiểm tra có những phần tử đang đc checked, nếu có thì cập nhật rate của phần tử và những phần tử đang được checked
        // gán biến lưu những phần tử đang checked (lọc)
        const isCheck = temp[index].workOrderRates.filter((i) => i.matchCard);
        // tính tổng rate của những phần tử sau khi lọc
        const currentTemp = isCheck.reduce((a, b) => a + b.productPerPage, 0);

        // cập nhật lại rate của bản thân phần tử
        temp[index].workOrderRates[index2].rated =
          (temp[index].workOrderRates[index2].productPerPage / currentTemp) *
          100;

        // cập nhật lại isEdit của phần tử đó
        temp[index].isEdit = true;
        isCheck.forEach(
          (i) => (i.rated = (i.productPerPage / currentTemp) * 100)
        );
        if (!temp[index].workOrderRates[index2].matchCard) {
          temp[index].workOrderRates[index2].rated = 0;
        }
        setRoutingRates(temp);
      }
    };

    const pagePermissions = () => {
      // Kiểm tra đường dẫn
      // check phân quyền bằng đường dẫn
      // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
      const path = window.location.pathname;
      const user = getUserSession() as User;
      const filteredData = user.webPermission.pageModel.filter((item) => {
        const itemNames = item.pageUrl.split(" ");
        return itemNames.some((name) => path.includes(name));
      });
      if (filteredData.length) {
        const permission = user.webPermission.pagePermissionModel.filter(
          (item) => item.pageId === filteredData[0].pageId
        );
        if (permission.length) {
          if (permission.findIndex((item) => item.functionId === "EDIT") > -1) {
            setIsEdit(true);
          }
        }
      }
    };

    // =================== EFFECT ==========================
    useEffect(() => {
      pagePermissions();
      setIsLoading(true);
      const getMatchCardCommandDetail = async () => {
        await rootStore.mCComandPresenter.getMCCommandDetail(
          rootStore.mCComandStore,
          matchCardCommandId
        );
        setMatchCardCommand(
          rootStore.mCComandStore.mCCommandDetailResponse.data
        );
        setRoutingRates(
          rootStore.mCComandStore.mCCommandDetailResponse.data?.routingRates
        );

        if (
          rootStore.mCComandStore.mCCommandDetailResponse.data?.workOrderMCs
        ) {
          setWORouting(
            rootStore.mCComandStore.mCCommandDetailResponse.data?.workOrderMCs.find(
              (item) =>
                item.workOrderCode ===
                rootStore.mCComandStore.mCCommandDetailResponse.data
                  ?.workOrderMCs[0].workOrderCode
            )?.workOrderRoutings
          );
        }
        setIsLoading(false);
      };
      getMatchCardCommandDetail();
    }, []);

    return (
      <div className="w-full py-3 px-5">
        <div className="mb-2">
          <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
            LỆNH GHÉP BÀI CHI TIẾT
          </h3>
        </div>

        {/* Form detail*/}
        {isLoading && <LoadingScreen />}
        <div className="w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300">
          <form className="w-full lg:grid lg:grid-cols-2 flex flex-col gap-2">
            {/* Mã ghép bài*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Lệnh thiết kế
              </label>
              <input
                disabled
                value={
                  matchCardCommand?.matchCardCode &&
                  matchCardCommand.matchCardCode
                }
                className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Công ty gia công in*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Công ty gia công in
              </label>
              <input
                disabled
                value={
                  matchCardCommand?.printCompany &&
                  matchCardCommand.printCompany
                }
                className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Tên hạng mục in*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Tên hạng mục in
              </label>
              <input
                disabled
                value={
                  matchCardCommand?.printItem && matchCardCommand.printItem
                }
                className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Số phiếu thiết kế*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Số phiếu thiết kế
              </label>
              <input
                disabled
                value={
                  matchCardCommand?.designVote && matchCardCommand.designVote
                }
                className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Danh sách LSX ghép bài*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Danh sách LSX ghép bài
              </label>
              <input
                disabled
                value={
                  matchCardCommand?.workOrderCodes &&
                  matchCardCommand?.workOrderCodes
                }
                className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Ngày yêu cầu có hàng in*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
                Ngày yêu cầu có hàng in
              </label>
              <input
                disabled
                value={
                  matchCardCommand?.printReqDate &&
                  matchCardCommand?.printReqDate
                }
                className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
          </form>
        </div>

        {/* tab danh sách LSX ghép bài chi tiết*/}
        <div className="w-full bg-white flex rounded mb-2  border border-neutral-300">
          <Box sx={[styles.MuiBoxRoot]} width={0}>
            <TabContext value={value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}
              >
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value={value}
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    sx={[styles.MuiButtonBaseRoot]}
                    key="rateMCCommand"
                    value="rateMCCommand"
                    label="Chia tỷ lệ ghép bài"
                  />
                  {matchCardCommand?.workOrderMCs.map((item, index) => {
                    return (
                      <Tab
                        key={index}
                        sx={[styles.MuiButtonBaseRoot]}
                        label={item.workOrderCode}
                        value={item.workOrderCode}
                      />
                    );
                  })}
                </Tabs>
              </Box>
              {/* Chia tỷ lệ theo ghép bài */}
              <TabPanel
                key="rateMCCommand"
                value="rateMCCommand"
                classes={{ root: "!p-3.5" }}
              >
                {isEdit && (
                  <div className="w-full flex justify-end mb-3.5">
                    <button
                      onClick={handleEditRouting}
                      className="flex items-center rounded-sm bg-primary text-white text-default py-1 px-2.5 "
                    >
                      <BiSave className="text-base" />
                      Lưu
                    </button>
                  </div>
                )}
                <div className="overflow-x-auto">
                  <table className="w-full text-default table-auto border-collapse space-collapse border-primary border-[1.5px]">
                    <thead className="font-medium text-gray-700  bg-gray-100">
                      <tr className="text-default">
                        <th
                          className="py-1.5 px-2 border w-[50px] text-center bg-primary text-white"
                          rowSpan={3}
                        >
                          STT
                        </th>
                        <th
                          className="py-1.5 px-2 border w-[100px] text-center bg-primary text-white"
                          rowSpan={3}
                        >
                          Công đoạn
                        </th>
                        {matchCardCommand?.workOrderMCs.map((item, index) => {
                          return (
                            <th
                              className="py-1.5 px-2 border text-default whitespace-nowrap text-center bg-primary text-white"
                              colSpan={3}
                              key={index}
                            >
                              {item.workOrderCode}
                            </th>
                          );
                        })}
                      </tr>
                      <tr>
                        {matchCardCommand?.workOrderMCs.map((item, index) => {
                          return (
                            <th
                              className="py-1.5 px-2 border text-default whitespace-nowrap text-center bg-primary text-white"
                              colSpan={3}
                              key={index}
                            >
                              {item.productCode} | {item.productName}
                            </th>
                          );
                        })}
                      </tr>
                      <tr>
                        {matchCardCommand?.workOrderMCs.map((item, index) => {
                          return (
                            <Fragment key={index}>
                              <th className="py-1.5 px-2 border w-[50px] text-center bg-primary text-white">
                                Số SP/Tờ/Công đoạn
                              </th>
                              <th className="py-1.5 px-2  border w-[50px] text-center bg-primary text-white">
                                Ghép bài
                              </th>
                              <th className="py-1.5 px-2  border w-[100px] text-center bg-primary text-white">
                                Tỷ lệ
                              </th>
                            </Fragment>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {routingRates &&
                        routingRates.map((item, index) => {
                          return (
                            <tr key={index}>
                              {/* stt */}
                              <td className="border whitespace-nowrap px-2 text-center">
                                {index + 1}
                              </td>
                              {/* Công đoạn */}
                              <td className="border whitespace-nowrap px-2">
                                {item.stepName}
                              </td>
                              {item.workOrderRates.map((item2, index2) => {
                                if (!item2.isDisable) {
                                  return (
                                    <Fragment key={item2.workOrderId}>
                                      {/* số tờ */}
                                      <td className="border whitespace-nowrap p-1 text-center">
                                        {item2.isDisable}
                                        <input
                                          onChange={(e) =>
                                            handleChangeValueProductPage(
                                              e,
                                              index,
                                              index2,
                                              item2
                                            )
                                          }
                                          type="text"
                                          defaultValue={item2.productPerPage}
                                          className=" w-full text-right text-gray-700 border border-gray-300 px-2 py-0.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                                        />
                                      </td>
                                      {/* ghép bài */}
                                      <td className="border whitespace-nowrap px-2 text-center">
                                        <Checkbox
                                          checked={item2.matchCard}
                                          classes={{ root: "!p-0" }}
                                          onChange={() => {
                                            handleCalcRate(
                                              index,
                                              index2,
                                              item2
                                            );
                                          }}
                                        />
                                      </td>
                                      {/* tỷ lệ */}
                                      <td className="border whitespace-nowrap px-2 text-center">
                                        {item2.rated && item2.rated !== 0
                                          ? `${formatNumber(item2.rated, 2)}%`
                                          : ""}
                                      </td>
                                    </Fragment>
                                  );
                                } else {
                                  return (
                                    <Fragment key={index2}>
                                      <td className="border whitespace-nowrap px-2 text-center" />
                                      <td className="border whitespace-nowrap px-2 text-center" />
                                      <td className="border whitespace-nowrap px-2 text-center" />
                                    </Fragment>
                                  );
                                }
                              })}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </TabPanel>

              {/* map work order code */}
              {matchCardCommand?.workOrderMCs.map((item, index) => {
                return (
                  <TabPanel
                    key={index}
                    value={item.workOrderCode}
                    classes={{ root: "!p-3.5" }}
                  >
                    <div className="flex items-center">
                      <label className="font-medium text-default text-gray-700 sm:text-end ">
                        LSX:
                      </label>
                      <p className="= text-gray-700 px-3 text-default">
                        {item.workOrderCode}
                      </p>
                    </div>
                    <div className="flex items-center">
                      <label className="font-medium text-default text-gray-700 sm:text-end ">
                        TP/BTP:
                      </label>
                      <p className="= text-gray-700 px-3 text-default">
                        {item.productName}
                      </p>
                    </div>

                    {/* table */}
                    <div className={`overflow-x-auto mt-3`}>
                      <TableContainer
                        component={Paper}
                        className="w-full table-auto overflow-y-hidden space-collapse text-default"
                      >
                        <Table
                          aria-label="simple table"
                          sx={styles.borderInherit}
                        >
                          <TableHead className="font-medium text-gray-700 text-default bg-gray-100">
                            <TableRow>
                              {column?.map((item, index) => {
                                return (
                                  <TableCell
                                    sx={[styles.MuiTableCellRoot]}
                                    key={index}
                                    align={`${
                                      item.align === "text-center"
                                        ? "center"
                                        : "inherit"
                                    }`}
                                    scope="col"
                                    className={`${item.visible ? "" : "hidden"}
                          ${item.sticky}
                           py-2 px-2 border min-w-[120px] text-left bg-primary text-white`}
                                  >
                                    {item.columnName}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {WORouting &&
                              WORouting.map((item2, index) => (
                                <TableRow
                                  key={index}
                                  className={`${
                                    index % 2 !== 0 ? "bg-gray-50" : "bg-white"
                                  } hover:bg-gray-100`}
                                >
                                  {/* thứ tự công đoạn */}
                                  <TableCell
                                    align="right"
                                    sx={[
                                      styles.MuiTableCellRootTd,
                                      styles.sticky1,
                                    ]}
                                    className="border whitespace-nowrap"
                                  >
                                    <div className="">{item2.orderIndex}</div>
                                  </TableCell>
                                  {/* Mã công đoạn */}
                                  <TableCell
                                    align="left"
                                    sx={[
                                      styles.MuiTableCellRootTd,
                                      styles.sticky2,
                                    ]}
                                    className="sticky z-10 shadow-3xl left-0 border whitespace-nowrap p-1"
                                  >
                                    {item2.stepCode}
                                  </TableCell>
                                  {/* tên công đoạn */}
                                  <TableCell
                                    align="left"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border whitespace-nowrap relative"
                                  >
                                    <Tooltip title={item2.stepName}>
                                      <div className="text-truncate truncate w-[300px]">
                                        {item2.stepName}
                                      </div>
                                    </Tooltip>
                                  </TableCell>
                                  {/* hướng dẫn sản xuất */}
                                  <TableCell
                                    align="left"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border whitespace-nowrap relative"
                                  >
                                    <div className="text-truncate truncate w-[300px]">
                                      {item2.productionGuide}
                                    </div>
                                    <div className="text-tooltip">
                                      {item2.productionGuide}
                                    </div>
                                  </TableCell>
                                  {/* NVL sử dụng */}
                                  <TableCell
                                    align="left"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border whitespace-nowrap relative"
                                  >
                                    {item2.componentUsed}
                                  </TableCell>
                                  {/* Khuôn sử dụng */}
                                  <TableCell
                                    align="left"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border whitespace-nowrap relative"
                                  >
                                    {item2.mold}
                                  </TableCell>
                                  {/* số SP/Tờ/ Công đoạn */}
                                  <TableCell
                                    align="right"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border "
                                  >
                                    {formatNumber(item2.productPerPage, 0)}
                                  </TableCell>
                                  {/* số lượng thực hiện theo từng công đoạn */}
                                  <TableCell
                                    align="right"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border "
                                  >
                                    {formatNumber(item2.productPerStep, 0)}
                                  </TableCell>
                                  {/* đơn vị tính */}
                                  <TableCell
                                    align="left"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    {item2.unit}
                                  </TableCell>
                                  {/* Tổng số sản phẩm */}
                                  <TableCell
                                    align="right"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    {formatNumber(item2.totalQuantity, 0)}
                                  </TableCell>
                                  {/* % Ước tính hoàn thành */}
                                  <TableCell
                                    align="right"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    {item2.estimateComplete &&
                                      formatNumber(item2.estimateComplete, 3)}
                                  </TableCell>
                                  {/* thời gian chuẩn bị */}
                                  <TableCell
                                    align="right"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    {item2.setupTime}
                                  </TableCell>
                                  {/* Thời gian định mức (min) */}
                                  <TableCell
                                    align="right"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    {item2.ratedTime}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    <Checkbox
                                      readOnly
                                      checked={item2.matchCard}
                                      color="primary"
                                      classes={{ root: "!p-0" }}
                                      // onChange={() => {
                                      //   const temp = [...WORouting];
                                      //   temp[
                                      //     index
                                      //   ].matchCard = !item2.matchCard;
                                      //   setWORouting(temp);
                                      // }}
                                    />
                                  </TableCell>
                                  {/* tỷ lệ */}
                                  <TableCell
                                    align="center"
                                    sx={[styles.MuiTableCellRootTd]}
                                    className="border"
                                  >
                                    {item2.rated &&
                                      `${formatNumber(item2.rated, 2)}%`}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </TabPanel>
                );
              })}
            </TabContext>
          </Box>
        </div>
      </div>
    );
  });
}
